<template>
    <v-container fluid grid-list-md class="horizontal-padding-content">
        <v-row>
            <v-col cols="12">
                <v-card class="rounded-card" height="100%">
                    <v-card-title class="primary--text pt-1 pb-0">
                        <v-row :class="{ 'pb-0 mb-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }">
                            <v-col order-lg="2" cols="12" lg="6" class="text-uppercase primary--text text-center font-weight-black">
                                Historial de facturación de intereses
                            </v-col>
                            <v-col  order-lg="3">
                              <ExportTable
                                :fileName="fileName"
                                :mapFunction="mapFunction"
                                :dataToExport="filteredList"
                                :headers="excelHeaders"
                              />
                            </v-col>
                            <v-col order-lg="1" cols="12" lg="3">
                                <v-menu
                                  :close-on-content-click="true"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field
                                      class="capitalize-input"
                                      outlined
                                      dense
                                      label="Mes"
                                      append-icon="mdi-menu-down"
                                      v-on="on"
                                      v-model="dateFormatted"
                                    />
                                  </template>
                                  <v-date-picker
                                    type="month"
                                    v-model="month"
                                    locale="es"
                                    @change="loadRecords()"
                                    />
                              </v-menu>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xs && !$vuetify.breakpoint.sm" order-lg="3" cols="0" lg="3" class="text-right">
                                <!-- <v-chip
                                  v-model="currencyFilterUSD"
                                  class="mr-2"
                                  :class="{'active-chip': currencyFilterUSD === true,  'inactive-chip': currencyFilterUSD === false }"
                                  @click="toggleFilter('currencyFilterUSD')">USD</v-chip>
                                <v-chip
                                  v-model="currencyFilterMXN"
                                  class="mr-2"
                                  :class="{'active-chip': currencyFilterMXN === true,  'inactive-chip': currencyFilterMXN === false }"
                                  @click="toggleFilter('currencyFilterMXN')">MXN</v-chip> -->
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text
                      class="primary--text pt-1 pb-0"
                      :class="{ 'pt-0 mt-0': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
                    >
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                  :headers="headers"
                                  :items="filteredList"
                                  :loading="loading"
                                  loading-text="Cargando datos"
                                  no-data-text="No hay datos para mostrar"
                                  class="elevation-2"
                                  :class="{ 'mt-0 pt-0': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs }"
                                  :footer-props="{
                                    'items-per-page-all-text': 'Todos',
                                    'items-per-page-options': [-1],
                                    'disable-pagination': true
                                  }">
                                    <template v-slot:[`item.invoiceType`]="{ item }">
                                        {{ item.invoiceType ? 'Ingreso' : 'Egreso' }}
                                    </template>
                                    <template v-slot:[`item.active`]="{ item }">
                                        {{ item.active ? 'Activa' : 'Cancelada' }}
                                    </template>
                                    <template v-slot:[`item.amount`]="{ item }">
                                        {{ item.amount | currency }}
                                    </template>
                                    <template v-slot:[`item.action`]="{ item }">
                                        <v-btn rounded small class="ma-2" dark color="#1374F2" @click="download('pdf', item)">
                                            <v-icon left>mdi-file-pdf</v-icon> PDF
                                        </v-btn>
                                        <v-btn rounded small class="ma-2" dark color="#1374F2" @click="download('xml', item)">
                                            <v-icon left>mdi-file-document</v-icon> XML
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import InvoiceService from '@/services/InvoiceService'
import Utils from '@/common/utils.js'
import moment from 'moment'
import ExportTable from '@/components/ExportTable'

export default {
  name: 'InvoicesHistory',
  components: {
    ExportTable
  },
  data () {
    return {
      loading: false,
      searchRecord: {
        startDate: moment(new Date()).startOf('month').locale('es').format('YYYY-MM-DD'),
        endDate: moment(new Date()).endOf('month').locale('es').format('YYYY-MM-DD'),
        created: true,
        active: true
      },
      // currencyFilterUSD: true,
      // currencyFilterMXN: true,
      records: [],
      month: new Date().toISOString().substr(0, 10),
      dateFormatted: moment(new Date()).locale('es').format('MMMM YYYY'),
      filteredList: [],
      headers: [
        { text: 'Folio', value: 'invoiceFolio', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Fecha de Emisión', value: 'emittionDate', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'periodo Facturado', value: 'month', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Monto Facturado', value: 'amount', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Moneda', value: 'currency', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Estatus', value: 'active', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Tipo de Comprobante', value: 'invoiceType', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Factura', value: 'factoringDocumentFolio', align: 'center', class: 'primary--text font-weight-black text-uppercase' },
        { text: 'Descarga', value: 'action', align: 'center', class: 'primary--text font-weight-black text-uppercase' }
      ],
      fileName: 'Facturas',
      excelHeaders: {
        invoiceFolio: 'Folio',
        emittionDate: 'F. Emisión',
        month: 'Periodo Facturado',
        amount: 'Monto Facturado',
        currency: 'Moneda',
        factoringDocumentFolio: 'Factura'
      }
    }
  },
  beforeCreate () {
    if (!this.$store.getters.isLoggedIn) {
      const routeData = this.$router.resolve({ name: 'login' })
      window.open(routeData.href, '_self')
    }
  },
  mounted () {
    if (this.$store.getters.isLoggedIn) {
      this.loadRecords()
    }
  },
  watch: {
    month (val) {
      this.dateFormatted = moment(this.month).locale('es').format('MMMM YYYY')
      this.searchRecord.startDate = moment(this.month).startOf('month').locale('es').format('YYYY-MM-DD')
      this.searchRecord.endDate = moment(this.month).endOf('month').locale('es').format('YYYY-MM-DD')
    }
  },
  methods: {
    mapFunction (item) {
      return Object.assign({
        invoiceFolio: item.invoiceFolio,
        emittionDate: item.emittionDate,
        month: item.month,
        amount: item.amount,
        currency: item.currency,
        factoringDocumentFolio: item.factoringDocumentFolio
      })
    },
    processInvoiceList () {
      this.filteredList = []
      for (const record of (this.records || [])) {
        if (!record.InvoicingDetails || record.InvoicingDetails.length === 0) {
          this.filteredList.push({
            invoiceFolio: record.folio,
            emittionDate: moment(record.emittionDate).locale('es').format('MMMM DD, YYYY'),
            currency: record.currency,
            active: record.active,
            invoiceType: record.invoiceType,
            facturamaId: record.facturamaId,
            amount: parseFloat(record.amount || 0) + parseFloat(record.iva || 0),
            factoringDocumentFolio: this.getFoliosText(record.creditFolios),
            month: moment(this.month).locale('es').format('MMMM'),
            rowspan: 1
          })
        } else {
          let index = 0
          for (const recordDetail of (record.InvoicingDetails || [])) {
            this.filteredList.push({
              invoiceFolio: record.folio,
              emittionDate: moment(record.emittionDate).locale('es').format('MMMM DD, YYYY'),
              currency: record.currency,
              active: record.active,
              invoiceType: record.invoiceType,
              facturamaId: record.facturamaId,
              amount: parseFloat(recordDetail.subTotal || 0) + parseFloat(recordDetail.iva || 0),
              factoringDocumentFolio: recordDetail.factoringDocumentFolio,
              month: moment(this.month).locale('es').format('MMMM'),
              rowspan: index === 0 ? record.InvoicingDetails.length : 0
            })
            index++
          }
        }
      }
    },
    async loadRecords () {
      const loader = this.$loading.show()
      this.loading = true
      this.searchRecord.clientId = this.$store.getters.user.client.clientId
      this.searchRecord.created = true
      this.searchRecord.active = true
      try {
        const data = await InvoiceService.listInvoices(this.searchRecord)
        this.records = data.invoices
        this.processInvoiceList()
        loader.hide()
        this.loading = false
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    },
    getFoliosText (folios) {
      let returnFolios = ''
      for (const folio of folios) {
        returnFolios = folio + ' '
      }
      return returnFolios
    },
    async download (fileType, item) {
      const loader = this.$loading.show()
      const params = {
        fileType: fileType,
        id: item.facturamaId
      }
      try {
        const { file } = await InvoiceService.downloadInvoiceByID(params)
        const blob = Utils.converBase64toBlob(file.Content, 'application/' + fileType) // ContentType
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `Intereses de ${item.factoringDocumentFolio ? item.factoringDocumentFolio : item.invoiceFolio}`
        loader.hide()
        link.click()
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    }
    // toggleFilter (filter) {
    //     this[filter] = !this[filter]
    // }
  }
}
</script>

<style>
    .capitalize-input input {
        text-transform: uppercase !important;
        color: #0420BF!important;
        font-weight: 900 !important;
        font-size: 20px !important;
    }
</style>
